/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path apicaller
 * @description Session constants for the APIs
 */
import { SESSION_TOKEN } from "./api-consts";
import { readCookieValue } from "../utils/url-utils";

// Sessiontoken (=jwt) is passed either in http header or in cookie,
// configured in server. If cookie is used, no token is stored to sessionStorage.
const initSession = (sessionToken: string | null): void => {
  if (!sessionToken) {
    throw new Error("Session initialization failed");
  }
  try {
    window.sessionStorage.setItem(SESSION_TOKEN, sessionToken);
  } catch (e) {
    // Ignore if sessionStorage not available (e.g. private mode)
  }
};
const destroySession = (): void => {
  try {
    window.sessionStorage.removeItem(SESSION_TOKEN);
  } catch (e) {}
  // Note: when server uses cookie-based JWT, the cookie is cleared by calling logout or by server
};

const JWT_COOKIE_NAME = "jwt"; // Some servers use this cookie name for the JWT

/**
 * Returns the session token from sessionStorage or from cookie (when server uses cookie-based JWT).
 * Needed so session expiry and timeout warning work when token is only in cookie.
 */
const getSessionToken = (): string | null => {
  try {
    const fromStorage = window.sessionStorage.getItem(SESSION_TOKEN);
    if (fromStorage) return fromStorage;
  } catch (e) {}
  const fromCookie = readCookieValue(SESSION_TOKEN) || readCookieValue(JWT_COOKIE_NAME);
  if (fromCookie) return fromCookie;
  return null;
};

const apiSessionStorageExport = {
  initSession,
  getSessionToken,
  destroySession,
};
export default apiSessionStorageExport;
